const { cxt } = require('./context');

const abn = [
  'abn',
  'whitespace',
  'numeric',
  cxt('min-length', { length: 11 }),
  cxt('max-length', { length: 11 }),
];

const acn = [
  'whitespace',
  'numeric',
  cxt('min-length', { length: 9 }),
  cxt('max-length', { length: 9 }),
];

const acnRequired = [
  'whitespace',
  'numeric',
  cxt('min-length', { length: 9 }),
  cxt('max-length', { length: 9 }),
  'required'
];

const abnRequired = [
  'abn',
  'whitespace',
  'numeric',
  cxt('min-length', { length: 11 }),
  cxt('max-length', { length: 11 }),
];

module.exports = {
  abn,
  acn,
  acnRequired,
  abnRequired
};
